import _slicedToArray from "/home/denis/workspace/smartheat/pump-services/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _defineProperty from "/home/denis/workspace/smartheat/pump-services/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _styled from "styled-components";

var _components;

import React, { useState } from "react";
import { ReactComponent as MenuIcon } from "@svgr/webpack?-svgo,+titleProp,+ref!@smartheat/common/svg/menu.svg";
import { Header } from "../Header/Header";
import { MenuScreen } from "./screens/MenuScreen";
import { ControlScreen } from "./screens/ControlScreen";
import { ErrorsScreen } from "./screens/ErrorsScreen";
import { SensorsScreen } from "./screens/SensorsScreen/SensorsScreen";
import { ParamsScreen } from "./screens/ParamsScreen";
import { ScreenKind } from "./screens/ScreenKind";
var components = (_components = {}, _defineProperty(_components, ScreenKind.Menu, MenuScreen), _defineProperty(_components, ScreenKind.Control, ControlScreen), _defineProperty(_components, ScreenKind.Alarms, ErrorsScreen), _defineProperty(_components, ScreenKind.Sensors, SensorsScreen), _defineProperty(_components, ScreenKind.Params, ParamsScreen), _components);

var Container = _styled.div.withConfig({
  displayName: "ServiceMenuScreen__Container",
  componentId: "sc-815xu8-0"
})(["flex:1;display:flex;flex-direction:column;height:100%;"]);

export function ServiceMenuScreen(_ref) {
  var title = _ref.title,
      serviceMenu = _ref.serviceMenu,
      backTo = _ref.backTo,
      deviceScreens = _ref.deviceScreens,
      menuApi = _ref.menuApi;

  var _useState = useState(ScreenKind.Menu),
      _useState2 = _slicedToArray(_useState, 2),
      screen = _useState2[0],
      setScreen = _useState2[1];

  var handleBackClick = function handleBackClick() {
    if (screen.is(ScreenKind.DeviceScreen) && screen.subscreen) {
      setScreen(ScreenKind.DeviceScreen());
    } else {
      setScreen(ScreenKind.Menu);
    }
  };

  var hasDeviceMenu = !!deviceScreens;
  var CurrentScreen = screen.is(ScreenKind.DeviceScreen) ? deviceScreens[screen.subscreen || ScreenKind.DeviceScreen] : components[screen];
  return /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Header, {
    onBack: !screen.is(ScreenKind.Menu) ? handleBackClick : undefined,
    backTo: screen.is(ScreenKind.Menu) ? backTo : undefined,
    actionIcon: menuApi ? MenuIcon : undefined,
    onAction: menuApi && menuApi.open
  }), CurrentScreen && /*#__PURE__*/React.createElement(CurrentScreen, {
    title: title,
    setScreen: setScreen,
    serviceMenu: serviceMenu,
    hasDeviceMenu: hasDeviceMenu,
    screen: screen
  }));
}